<template>
  <el-select :value="teamLabel" placeholder="请选择" multiple @remove-tag="clearHandle">
    <el-option :value="id" :label="label">
      <el-tree id="tree-option"
               ref="selectTree"
               :data="teamList"
               :props="defaultProps"
               :node-key="defaultProps.value"
               :default-expanded-keys="defaultExpandedKey"
               @node-expand="handleNodeExpand"
               :load="loadNode1"
               lazy
               :show-checkbox="isShowCheckBox"
               @check-change="handleNodeClick"
               :expand-on-click-node="false"
               :check-on-click-node="true"
      >
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
  import {tagRoles,roleUser} from '../../api/api'

  export default {
    name: 'select-tree',
    props: {
      teamList: Array,
      teamId: Array,
      teamLabel: Array,
      proId:null,
    },
    data() {
      return {
        //选择树==============================
        data: [],
        defaultProps: {
          children: 'children',
          label:
            'label',
          value:
            'id',
          disabled: 'disabled'
        },
        value: [],
        id: null,
        label: null,
        defaultExpandedKey: [],
        isShowCheckBox: true,
        //====选择树结束=================
      }
    },
    methods: {
      //选择树==================================================================
      //加载数据
      loadNode1(node, resolve) {
        let id = node.key;
        if (node.level == 1) {
          roleUser({key:id,comId:this.GLOBAL.user.comId,proId: this.proId}, this.GLOBAL.header).then(result => {
            if (result.success) {
              return resolve(result.data);
            }
          })
        }
        if (node.level > 1) {
          return resolve([]);
        }
      },
      // 切换选项
      handleNodeClick(node, isChecked,sel) {
        let level = node.level;
        if (isChecked && level !=1 && this.teamLabel.indexOf(node.label) == -1) {
          this.teamLabel.push(node.label);
          this.teamId.push(node.id);
        } else if (!isChecked) {
          this.clearHandle(node.label);
        }
      },
      // 清除选中
      clearHandle(node) {
        let nodes = this.$refs.selectTree.getCheckedNodes();
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].label == node) {
            this.$refs.selectTree.setChecked(nodes[i], false, true)
          }
        }
        let index = this.teamLabel.indexOf(node);
        if (index > -1) {
          this.teamLabel.splice(index, 1);
          this.teamId.splice(index, 1);
        }
      },
      //节点展开事件
      handleNodeExpand(data, node, self) {
        data.disabled = false;
      }
      //选择树结束==============================
    },
    mounted() {
    }
  }
</script>

<style scoped>
  /*选择树================================*/
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
    height: auto;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }

  .el-select-dropdown__item.selected {
    font-weight: normal;
  }

  ul li >>> .el-tree .el-tree-node__content {
    height: auto;
    padding: 0 20px;
  }

  .el-tree-node__label {
    font-weight: normal;
  }

  .el-tree >>> .is-current .el-tree-node__label {
    color: #409EFF;
    font-weight: 700;
  }

  .el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
    color: #606266;
    font-weight: normal;
  }

  /*选择树================================*/
</style>



// WEBPACK FOOTER //
// src/components/command/WorkTeamList.vue